// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/chartist'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { firestorePlugin } from 'vuefire'
import * as VueGoogleMaps from "vue2-google-maps";

import firebase from 'firebase'
import 'firebase/auth'
import CoreuiVue from '@coreui/vue';

import VueAgile from 'vue-agile'
import VueSlickCarousel from 'vue-slick-carousel'
import FlagIcon from 'vue-flag-icon'


Vue.use(FlagIcon);
Vue.use(VueAgile)
Vue.use(CoreuiVue);
Vue.use(firestorePlugin)
Vue.use(VueSlickCarousel)
Vue.prototype.$UserAuth = null

Vue.config.productionTip = false


Vue.use(VueGoogleMaps, {
  load: { key: "AIzaSyDx7GyCznFoxl0kDKO7H2-UW3KcXCMuuGE" }
});
let app;


 if (!app) {
    app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
}
